// extracted by mini-css-extract-plugin
export default {"root":"classes_root__WGT4T"};